import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface PopupState {
  message: string;
}

const initialState: PopupState = {
  message: "",
};

const popupSlice = createSlice({
  name: "popup",
  initialState,
  reducers: {
    openPopup: (state, action: PayloadAction<string>) => {
      state.message = action.payload;
    },
    closePopup: (state) => {
      state.message = "";
    },
  },
});

export const { openPopup, closePopup } = popupSlice.actions;

export default popupSlice.reducer;
